module.exports = __webpack_public_path__ + "img/edit.bbd76ca0.svg";